import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../api";

export default function ResetPassword() {
  const { uid, token } = useParams();
  const navigate = useNavigate();

  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMessage("");
    setError("");

    if (newPassword1 !== newPassword2) {
      setError("Passwords do not match.");
      return;
    }

    if (newPassword1.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (!uid || !token) {
      setError("Invalid or expired password reset link.");
      return;
    }

    setLoading(true);

    try {
      const response = await api.post(
        "/api/auth/password/reset/confirm/",
        {
          uid,
          token,
          new_password1: newPassword1,
          new_password2: newPassword2,
        }
      );

      console.log("Password reset response:", response.data);

      setMessage(
        "Password has been reset successfully. Redirecting..."
      );

      setTimeout(() => {
        navigate("/login");
      }, 2000);
    } catch (err) {
      console.error("Password reset error:", err);

      const data = err.response?.data;

      if (data) {
        if (typeof data === "string") {
          setError(data);
        } else if (data.detail) {
          setError(data.detail);
        } else if (data.new_password1) {
          setError(
            Array.isArray(data.new_password1)
              ? data.new_password1.join(" ")
              : data.new_password1
          );
        } else if (data.new_password2) {
          setError(
            Array.isArray(data.new_password2)
              ? data.new_password2.join(" ")
              : data.new_password2
          );
        } else {
          setError(
            Object.values(data)
              .flat()
              .join(" ")
          );
        }
      } else {
        setError(
          "Unable to reset password. Please try again."
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5EFE3] px-4">
      <div className="w-full max-w-md bg-[#FFFDF8] border border-[#E5D9C7] rounded-2xl shadow-xl p-8">

        {/* TITLE */}
        <div className="text-center mb-7">
          <h1 className="text-3xl font-bold text-[#183F3D]">
            Reset Password
          </h1>

          <p className="text-[#81786B] mt-2">
            Enter your new password.
          </p>
        </div>

        {/* SUCCESS */}
        {message && (
          <div className="mb-5 rounded-xl bg-[#E4F3ED] border border-[#B9DDD2] text-[#17665F] p-3 text-sm">
            {message}
          </div>
        )}

        {/* ERROR */}
        {error && (
          <div className="mb-5 rounded-xl bg-[#FDECEC] border border-[#F3CACA] text-red-600 p-3 text-sm">
            {error}
          </div>
        )}

        {/* FORM */}
        <form onSubmit={handleSubmit}>

          {/* NEW PASSWORD */}
          <div className="mb-5">
            <label
              htmlFor="new-password"
              className="block mb-2 font-medium text-[#3F4946]"
            >
              New Password
            </label>

            <input
              id="new-password"
              type="password"
              value={newPassword1}
              onChange={(e) =>
                setNewPassword1(e.target.value)
              }
              placeholder="Enter new password"
              className="
                w-full
                border
                border-[#D8CCB8]
                rounded-xl
                p-3
                bg-[#FDF9F1]
                text-[#183F3D]
                placeholder:text-[#A49A8B]
                focus:outline-none
                focus:ring-2
                focus:ring-[#0F6B68]
                focus:border-[#0F6B68]
                transition
              "
              required
              minLength={8}
            />
          </div>

          {/* CONFIRM PASSWORD */}
          <div className="mb-6">
            <label
              htmlFor="confirm-password"
              className="block mb-2 font-medium text-[#3F4946]"
            >
              Confirm Password
            </label>

            <input
              id="confirm-password"
              type="password"
              value={newPassword2}
              onChange={(e) =>
                setNewPassword2(e.target.value)
              }
              placeholder="Confirm new password"
              className="
                w-full
                border
                border-[#D8CCB8]
                rounded-xl
                p-3
                bg-[#FDF9F1]
                text-[#183F3D]
                placeholder:text-[#A49A8B]
                focus:outline-none
                focus:ring-2
                focus:ring-[#0F6B68]
                focus:border-[#0F6B68]
                transition
              "
              required
              minLength={8}
            />
          </div>

          {/* SUBMIT */}
          <button
            type="submit"
            disabled={loading}
            className="
              w-full
              bg-[#0F6B68]
              hover:bg-[#0A5552]
              disabled:bg-[#A9B9B5]
              disabled:cursor-not-allowed
              text-white
              rounded-xl
              p-3
              font-semibold
              shadow-md
              hover:shadow-lg
              transition
            "
          >
            {loading
              ? "Resetting..."
              : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}